import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=1c1a9a2b&scoped=true&"
import script from "./PaymentLink.vue?vue&type=script&lang=ts&"
export * from "./PaymentLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a9a2b",
  null
  
)

export default component.exports